import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=8ffd4ef0&scoped=true&"
import script from "./FormEdit.vue?vue&type=script&lang=ts&"
export * from "./FormEdit.vue?vue&type=script&lang=ts&"
import style0 from "./FormEdit.vue?vue&type=style&index=0&id=8ffd4ef0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffd4ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ffd4ef0')) {
      api.createRecord('8ffd4ef0', component.options)
    } else {
      api.reload('8ffd4ef0', component.options)
    }
    module.hot.accept("./FormEdit.vue?vue&type=template&id=8ffd4ef0&scoped=true&", function () {
      api.rerender('8ffd4ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/FormEdit.vue"
export default component.exports